module.exports = __webpack_public_path__ + "assets/images/hdl_y.e8272165.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/hdl_y.png
// module id = 725
// module chunks = 1